import React from "react";
import { Modal, Button,Spinner  } from "react-bootstrap";

const GoldPaymentConfirmationModal = ({ show, onHide, onConfirm, amount,loading = false, }) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header  closeButton>
      <Modal.Title>Loan closure Warning  </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#f8f9fa" }}>
       <div> <p><i>Loan closure can only be processed at the branch. Please ensure your final payment is less than <strong>₹{amount}</strong>. For assistance, contact your branch directly
       </i></p></div>
        {/* if net PaymentAmount>=netamount then show mwssage " loan closing is not possible enter lower amount" */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
        {/* <Button variant="success" onClick={onConfirm} disabled={loading}>
  {loading ? "Processing..." : "Confirm"}
</Button> */}
      </Modal.Footer>
    </Modal>
  );
};

export default GoldPaymentConfirmationModal;
